import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
	Button, Col, Grid, Radio, Row,
} from 'react-bootstrap';
import { isEqual } from 'lodash';
import utils from '@utils';
import { QuickPaySummary } from './components';

class BulkInvoiceInfo extends Component {
	shouldComponentUpdate({ timeZoneId, sendEmailReceipt }) {
		const lastProps = this.props;

		return (
			!isEqual(timeZoneId, lastProps.timeZoneId)
			|| !isEqual(sendEmailReceipt, lastProps.sendEmailReceipt)
		);
	}

	render() {
		const {
			invoice, timeZoneId, sendEmailReceipt, updateData, onSubmit,
		} = this.props;

		const {
			TransactionSummaryItems = [],
			TotalOfficerPay,
			TotalJurisdictionFee,
			TotalOrganizationFee,
			RKPayFee,
			Tax,
			Total,
		} = invoice;

		return (
			<Fragment>
				<div className="margin-top-30">
					<Grid>
						<Row>
							<Col md={7} sm={12}>
								<div className="margin-bottom-30">
									<span className="font-size-24 font-bold">New Invoice</span>
								</div>

								<div className="margin-top-30 margin-bottom-30 visible-sm-block visible-xs-block">
									<div className="text-center">
										<div className="margin-bottom-20">
											<Button
												bsStyle="primary"
												className="form-control height-54 font-size-16"
												onClick={() => onSubmit(2)}
											>
												Pay Now
											</Button>
										</div>
										<div>
											<span className="color-gray-shuttle">Already have an account? </span>
											<a href="/login">Sign In now</a>
										</div>
									</div>
								</div>

								<div className="quickpay-bulk-invoice">
									<div className="margin-top-30 margin-bottom-20 position-relative">
										<div className="hidden-xs" id="quickpay-title-icon">
											<i className="rkf rkf-invoice text-primary font-size-26 margin-right-10" />
										</div>
										<div className="flex flex-align-items-top">
											<div className="visible-xs-block">
												<i className="rkf rkf-invoice text-primary font-size-20 margin-right-5" />
											</div>
											<div className="color-gray-shuttle">
												You have received a new invoice for off duty services. RollKall allows
												businesses to pay through either a credit card or ACH
											</div>
										</div>
									</div>

									<div className="margin-bottom-30">
										<Row className="bulk-invoice-table-header">
											<Col xs={5} className="font-bold font-size-16">Description</Col>
											<Col xs={2} className="font-bold font-size-16 text-right">Rate</Col>
											<Col xs={2} className="font-bold font-size-16 text-right">Qty</Col>
											<Col xs={3} className="font-bold font-size-16 text-right">Amount Due</Col>
										</Row>
										<For
											each="item"
											index="index"
											of={TransactionSummaryItems}
										>
											<Row
												key={`quickpay_invoce_item_${item.InvoiceId}`}
												className={`${index % 2 !== 0
													? 'bg-gray-whisper'
													: ''} padding-top-7 padding-bottom-7 flex flex-align-items-center`}
											>
												<Col xs={5}>
													<div className="font-semi-bold">{ `Invoice #${item.InvoiceId}` }</div>
													<div className="font-size-12">
														{ utils.parseUTCDateToTimeZone(item.StartDateTime, timeZoneId).format('MM/DD/YY H:mm') }
														{' '}
														{ item.Location }
													</div>
												</Col>
												<Col xs={2} className="text-right">{ utils.currencyFormatter(item.Rate) }</Col>
												<Col xs={2} className="text-right">{ item.Hours }</Col>
												<Col xs={3} className="text-right">{ utils.currencyFormatter(item.Amount) }</Col>
											</Row>
										</For>

										<Row className="padding-top-25 flex flex-align-items-center">
											<Col xs={3}>Receipt:</Col>
											<Col xs={9}>
												<div className="flex flex-align-items-center">
													<div>
														<Radio
															name="receipt"
															onChange={() => updateData('sendEmailReceipt', false)}
															checked={!sendEmailReceipt}
															className="margin-0"
														>
															None
														</Radio>
													</div>
													<div className="margin-left-20">
														<Radio
															name="receipt"
															onChange={() => updateData('sendEmailReceipt', true)}
															checked={sendEmailReceipt}
															className="margin-0"
														>
															Email
														</Radio>
													</div>
												</div>
											</Col>
										</Row>
									</div>
								</div>

								<div className="hidden-sm hidden-xs">
									<div className="flex flex-align-items-center flex-justify-content-end margin-top-30 margin-bottom-30">
										<div className="margin-right-20">
											<span className="color-gray-shuttle">Already have an account? </span>
											<a href="/login">Sign In now</a>
										</div>
										<div>
											<Button
												bsStyle="primary"
												className="width-166 height-54 font-size-16"
												onClick={() => onSubmit(2)}
											>
												Pay Now
											</Button>
										</div>
									</div>
								</div>
							</Col>
							<Col md={1} sm={12} />
							<Col md={4} sm={12}>
								<QuickPaySummary
									invoice={{
										Items                 : TransactionSummaryItems,
										JurisdictionFees      : TransactionSummaryItems,
										TotalServiceCharge    : RKPayFee,
										TotalJurisdictionFees : TotalJurisdictionFee,
										TotalCoordinatorFee   : TotalOrganizationFee,
										TotalInvoice          : Total,
										TotalOfficerPay,
										Tax,
									}}
									timeZoneId={timeZoneId}
									type="bulk"
									status="unpaid"
								/>
							</Col>
						</Row>
					</Grid>
				</div>

				<div className="margin-top-30 margin-bottom-50 visible-sm-block visible-xs-block">
					<Grid className="text-center">
						<div className="margin-bottom-20">
							<Button
								bsStyle="primary"
								className="form-control height-54 font-size-16"
								onClick={() => onSubmit(2)}
							>
								Pay Now
							</Button>
						</div>
						<div>
							<span className="color-gray-shuttle">Already have an account? </span>
							<a href="/login">Sign In now</a>
						</div>
					</Grid>
				</div>
			</Fragment>
		);
	}
}

BulkInvoiceInfo.propTypes = {
	invoice          : PropTypes.object,
	onSubmit         : PropTypes.func.isRequired,
	sendEmailReceipt : PropTypes.bool,
	timeZoneId       : PropTypes.string,
	updateData       : PropTypes.func.isRequired,
};

BulkInvoiceInfo.defaultProps = {
	invoice          : {},
	sendEmailReceipt : false,
	timeZoneId       : '',
};

export default BulkInvoiceInfo;
